export interface Analysis {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  author: string;
  readTime: string;
  tags: string[];
  cover: string;
  content: string[];
}

export const analyses: Analysis[] = [
  {
    id: "a1",
    title: "曼城高位压迫为何能持续90分钟？战术体系深度拆解",
    excerpt:
      "从后场出球结构到前场反抢落位，曼城用极致的站位纪律把高位压迫变成一种可持续的比赛方式，本文逐环节拆解这套体系的运转逻辑。",
    date: "2026-10-15",
    author: "战术研究室",
    readTime: "8 分钟",
    tags: ["英超", "曼城", "战术分析"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20tactics%20board%20with%20green%20pitch%20and%20abstract%20player%20positions%2C%20editorial%20sport%20illustration%20style%2C%20dark%20emerald%20tones%2C%20minimal%20geometric%20arrows&width=800&height=500&seq=analysis-a1-01&orientation=landscape",
    content: [
      "曼城的高位压迫并非单纯依靠跑动，而是建立在严密的区域划分与传球线路封锁之上。前场三人组负责引导对手把球传向边路，中场则在第一时间收缩形成人数优势。",
      "当对手被迫长传时，曼城的后防线提前压上，用造越位与第二落点争抢把风险转化为下一次进攻。这种「压迫—回收—再压迫」的循环，是球队体能分配合理的关键。",
      "值得注意的是，边后卫内收成为中场枢纽，让球队在丢球瞬间就拥有至少四名球员处于对手的传球半径内，这正是压迫能够持续整场的结构性原因。",
    ],
  },
  {
    id: "a2",
    title: "国家德比前瞻：皇马与巴萨的中场博弈将决定胜负走向",
    excerpt:
      "一边是强调纵向冲刺的快速转换，一边是追求控球渗透的阵地推进，两队中场的控制力之争，很可能直接决定这场焦点战的最终比分。",
    date: "2026-10-14",
    author: "前线观察",
    readTime: "6 分钟",
    tags: ["西甲", "皇家马德里", "巴塞罗那"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20versus%20football%20concept%20with%20two%20abstract%20green%20fields%20and%20light%20beams%2C%20editorial%20sport%20illustration%20style%2C%20warm%20orange%20and%20green%20tones%2C%20minimal%20geometric%20shapes&width=800&height=500&seq=analysis-a2-01&orientation=landscape",
    content: [
      "皇马擅长在中场抢断后三脚出球完成反击，维尼修斯与姆巴佩的纵深跑动是最大威胁。巴萨则需要通过中场三角短传把球权牢牢握在脚下。",
      "比赛的关键在于谁先建立中场人数优势。巴萨若能有效限制皇马的第一脚向前传球，就能把比赛拖入自己熟悉的节奏。",
      "从近期状态看，双方锋线效率都非常高，因此定位球与防守转换的细节处理，或许比阵地战更能决定最终结果。",
    ],
  },
  {
    id: "a3",
    title: "欧冠淘汰赛攻防转换：进球大战背后的防线隐患",
    excerpt:
      "本轮的欧冠比赛上演了多场进球大战，高节奏攻防转换固然精彩，但两队在防线组织上的漏洞同样暴露无遗，本文逐一分析。",
    date: "2026-10-15",
    author: "欧战评述",
    readTime: "7 分钟",
    tags: ["欧冠", "攻防转换", "防线"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20stadium%20at%20night%20with%20abstract%20light%20trails%20showing%20movement%2C%20editorial%20sport%20illustration%20style%2C%20deep%20green%20and%20gold%20tones%2C%20minimal%20geometric%20lines&width=800&height=500&seq=analysis-a3-01&orientation=landscape",
    content: [
      "高强度的攻防转换让比赛观赏性倍增，但也让后防线长期处于少防多的高风险状态。多数失球都来自中场丢球后的三秒内。",
      "两支球队在边路回收时的沟通明显不足，肋部空当被反复利用，这正是比分不断被改写的重要原因。",
      "想要在次回合占得先机，如何在保持进攻锐度的同时补强中场保护，是教练组必须解决的课题。",
    ],
  },
  {
    id: "a4",
    title: "中超进攻提速观察：本土前锋的机会在哪里",
    excerpt:
      "随着多支球队战术向快速反击倾斜，本土前锋获得了更多身后球的进攻机会，本文结合近期比赛数据解读这一变化。",
    date: "2026-10-13",
    author: "国内足坛",
    readTime: "5 分钟",
    tags: ["中超", "本土球员", "进攻"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20modern%20football%20field%20with%20abstract%20speed%20lines%20and%20green%20grass%2C%20editorial%20sport%20illustration%20style%2C%20teal%20and%20green%20tones%2C%20minimal%20geometric%20shapes&width=800&height=500&seq=analysis-a4-01&orientation=landscape",
    content: [
      "越来越多球队选择用简洁的纵向传递代替繁琐的横向倒脚，这直接提升了前场球员获得一对一机会的频率。",
      "本土前锋在无球跑动与前插时机上的进步，是这一变化中最值得关注的部分，把握机会的能力也在稳步提升。",
      "未来若能在射门选择上更加果断，本土前锋完全有机会在射手榜上占据更靠前的位置。",
    ],
  },
  {
    id: "a5",
    title: "世界杯小组赛前瞻：强强对话中的阵容轮换策略",
    excerpt:
      "密集赛程之下，如何在保成绩与护体能之间取得平衡，成为各支强队共同面对的难题，轮换策略将直接影响小组出线形势。",
    date: "2026-10-12",
    author: "国际赛事组",
    readTime: "6 分钟",
    tags: ["世界杯", "阵容轮换", "赛程"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20global%20football%20tournament%20concept%20with%20golden%20trophy%20glow%20and%20green%20field%2C%20editorial%20sport%20illustration%20style%2C%20warm%20gold%20tones%2C%20minimal%20geometric%20shapes&width=800&height=500&seq=analysis-a5-01&orientation=landscape",
    content: [
      "世界杯小组赛阶段的赛程密度极高，主力球员的体能恢复成为教练组排兵布阵的重要考量因素。",
      "合理的轮换不仅能保护核心球员，还能让更多替补获得比赛感觉，为淘汰赛阶段储备深度。",
      "从历史经验看，能在小组赛阶段保持阵容灵活性的球队，往往在淘汰赛中走得更远。",
    ],
  },
];